export default {
  //common
  app_name: '위니 스포츠',
  description : 'Winee Sports - 스포츠 분석의 모든 것. 위니에서 여러 스포츠 전문가와 아프리카 분석BJ들의 분석 데이터를 더 저렴하고 편리하게 구매하세요. 전문가들의 디테일한 데이터와 전문적인 스포츠 분석을 언제든지 구매할 수 있습니다.',
  ogImage : '/assets/image/og-image.png',
  ceo: '유정호',
  bus_no: '328-86-02953',
  app_address: '서울특별시 성동구 독서당로 441',
  app_tel: '010-4976-5985', //'070-4499-4801'
  app_email: 'hooo9032@gmail.com',
  app_mailno: '통신판매신고번호 : 2024-서울성동-0924',
  app_footer: '@2024 copyright all rights reserved',
  confirm: '확인',
  cancel: '취소',
  close: '닫기',
  ok: '네',
  no: '아니오',
  go: '바로가기',
  home: '홈',
  analyst_member: '분석위원',
  my_analyst: '내 분석데이터',
  item_purchase: '아이템구매',
  info: '정보',
  po_terms: '이용약관',
  po_privacy: '개인정보취급방침',
  po_refund: '취소 및 환불규정',
  intro: '소개',
  po_company: '회사소개',
  cs_center: '고객센터',
  today_selection: '오늘을 이기는 선택',
  bj_tab_name: '분석위원',
  bj_data: '분석위원 분석데이터',
  wn_bj: '분석위원',
  best_bj: '베스트 분석위원',
  partner_bj: '파트너 분석위원',
  event: '이벤트',
  event_result: '결과발표',
  find_id_pwd: '아이디/비밀번호 찾기',
  find_id: '아이디 찾기',
  find_pwd: '비밀번호 찾기',
  not_login: '아직 회원이 아니신가요?',
  signup: '회원가입',
  nim: '님',
  login: '로그인',
  logout: '로그아웃',
  logout_q: '로그아웃 하시겠습니까?',
  signout: '회원탈퇴',
  signout_q: '회원탈퇴 하시겠습니까?',
  pt: '포인트',
  point: ' 포인트',
  mypage: '마이페이지',
  po_charge: '포인트충전',
  coupon_register: '쿠폰등록',
  coupon_code_error: '쿠폰번호를 입력해주세요.',
  fav_bj: '즐겨찾기한 분석위원',
  fav_analyst: '즐겨찾기한 분석위원',
  member: '분석위원',
  all: '전체',
  more: '더보기',
  alert: '알림',
  question: '문의',

  //login&signup&find
  already_signup: '아직 회원이 아니신가요?',
  do: '하기',
  id: '아이디',
  pwd: '비밀번호',
  remeber_id: '아이디 기억하기',
  auto_login: '자동 로그인',
  forgot_id_pwd: '아이디/비밀번호를 잊으셨나요?',
  kakao_login: '카카오로 로그인',
  naver_login: '네이버로 로그인',
  goggle_login: '구글로 로그인',
  reset_pwd: '비밀번호 재설정',
  login_error: '아이디 또는 비밀번호가 올바르지 않습니다.\n(5회 실패. 5회 이상 실패 시 비밀번호 재설정이 필요합니다.)',
  pwd_5_error: '5회 실패, 5회 이상 실패 시 비밀번호 재설정이 필요합니다.',
  user_info: '회원정보',
  info_register: '정보입력',
  signup_complete: '가입완료',
  signup_desc: '※위니 서비스는 만 14세 이상 가입이 가능합니다.',
  email: '이메일',
  email_hint: '이메일을 입력하세요',
  auth: '인증하기',
  pwd_hint: '비밀번호를 입력하세요',
  pwd_d: '비밀번호 확인',
  nickname: '닉네임',
  nickname_hint: '닉네임을 입력하세요',
  double_check: '중복확인',
  phone: '휴대폰 번호',
  phone_hint: '휴대폰 번호를 입력하세요',
  invalid_hint: '휴대폰 번호는 11자로 입력하세요.',
  name: '이름',
  name_hint: '이름을 입력하세요',
  birthday: '생년월일',
  birthday_hint: '생년월일을 입력하세요',
  invalid_birthday: '생년월일은 8자로 입력하세요.',
  email_alarm: '이메일 수신동의',
  email_alarm_desc: '위니에서 주최하는 다양한 이벤트, 정보성 뉴스레터 및 광고 수신여부를 설정할 수 있습니다.',
  email_alarm_desc1: '이메일 수신에 동의합니다.',
  agree_all: '전체동의',
  agree_usage: '이용약관[필수]',
  agree_privacy: '개인정보 수집 및 이용[필수]',
  view_detail: '자세히보기',
  next: '다음',
  signup_completed: '회원가입이 완료되었습니다!',
  signup_completed_desc1: '위니의 회원이 되신 것을 환영합니다.',
  signup_completed_desc2: '로그인 후 모든 기능을 이용하실 수 있습니다.',
  signup_completed_desc3: '회원가입 내역 확인 및 수정은 마이페이지에서 가능합니다.',
  to_main: '메인화면으로',
  find_phone: '휴대폰으로 찾기',
  find_email: '이메일로 찾기',
  find_id_desc: '가입 당시 입력한 번호를 통해 아이디를 찾을 수 있습니다.',
  find_phone_desc: '가입 당시 입력한 번호를 통해 비밀번호를 찾을 수 있습니다.',
  find_email_desc: '가입 당시 입력한 이메일을 통해 비밀번호를 찾을 수 있습니다.',
  ask_cancel_auth: '현재 인증 확인을 취소하시겠습니까?',
  send_auth: '인증번호 발송',
  auth_hint: '인증번호 입력',
  re_auth: '재발송',
  auth_sent: '입력하신 번호로 인증번호가 발송되었습니다.',
  auth_sent_by_email: '입력하신 이메일로 인증번호가 발송되었습니다.',
  input_auth: '인증번호를 입력하세요.',
  mismatch_auth: '인증번호가 일치하지 않습니다.',
  find_id_result: '{0} 님의 아이디는 {1}입니다.',
  find_id_fail: '가입하신 아이디가 없습니다.\n위니의 회원이 되어주세요.',
  reset_pwd_desc: '새로운 비밀번호를 만들어 주세요.\n* 6자 이상 영문, 숫자 혼용 필수 (특수문자 가능)',
  change: '변경',
  new_pwd: '신규 비밀번호',
  new_pwd_d: '신규 비밀번호 재확인',
  pwd_error: '사용할 수 없는 비밀번호입니다.',
  pwd_length: '비밀번호는 6자 이상 입력해 주세요.',
  pwd_old_erro: '기존 비밀번호를 새 비밀번호로 재사용하실 수 없습니다.',
  pwd_mismatch: '비밀번호가 일치하지 않습니다.',
  reset_pwd_complete: '비밀번호 변경 완료',
  withdraw: '회원 탈퇴한 계정입니다.',
  withdraw_at: '{0}\n탈퇴일: {1}',
  invalid_email: '이메일 양식이 맞지 않습니다.',
  invalid_pwd: '비밀번호 양식이 맞지 않습니다. (6~15자리 입력)',
  not_auth: '본인인증을 완료해 주세요.',
  invalid_nickname: '닉네임 양식이 맞지 않습니다.',
  valid_nickname: '사용 가능한 닉네임입니다.',
  valid_email: '사용 가능한 이메일입니다.',

  //메인
  site_title: '위니 스포츠',
  main: '위니 스포츠',
  dashboard_top5: '이 주의 TOP5',
  dashboard_go_special : '스폐셜데이터 보러가기',
  month_top5: '이번 달 TOP5 분석위원',
  week_top5: '이번 주 TOP5 분석위원',
  straight_rank: '연승 순위',
  share_rate: '수익률',
  sale_amount: '판매량',
  top_member: 'TOP{0} 분석위원\n{1}',

  //위니 데이터
  wn_data: '전체 분석데이터',
  data_all: '분석글 전체',
  price_p: '가격(P)',
  data_page1: '전체 : {0}건',
  data_page2: '페이지 : {0} / {1}',
  daily_popup_desc: '오늘의 스페셜은 단폴베팅으로 베팅하기에도 충분히 가치가 있는 오늘의 경기 중 가장 좋아보이는 경기에 대한 정밀 분석입니다.<br>오늘의 스페셜은 국내 배당 기준 1.7배 이상의 핸디캡 언오버 위주로 이루어져 있으며, 미적중 시에는 구매금액의 100% 모두 환불해 드립니다',

  //BJ
  bj_winee: '분석위원',
  bj_detail: '데이터 상세',
  bj_register: '분석 데이터 등록',
  bj_game_article : '분석위원 분석데이터',
  bj_betting_special : '스폐셜데이터',
  bj_pm_game: '분석데이터(오후)',
  bj_eve_game: '분석데이터(저녁)',
  bj_pm_title: '오후 경기 분석',
  bj_eve_title: '저녁 경기 분석',
  analyst_article: '분석 글',
  analyst_content: '분석 내용',
  data_new_input: '분석글을 입력하세요.',
  make: '작성하기',
  do_modify: '수정하기',
  title_hint: '제목을 입력하세요',
  al_content_hint: '분석글을 입력하세요',
  title: '제목',
  article_type : "구분",
  article_type_pm : "오후",
  article_type_eve : "저녁",
  article_type_data : "데이터",
  game_start_time: '경기 시작 시간',
  input_time: '경기 시작 시간을 입력하세요',
  bj: '분석위원',
  current: '현) ',
  active_period: '활동 시기',
  week_sale: '주간 판매왕',
  week_hit: '주간 적중왕',
  recent_5_hit: '최근 1주 적중률',
  add_like: '즐겨찾기 추가',
  go_analyst: '분석 보러 가기',
  main_pro: '주요 적중률',
  hit: '적중률',
  hit_rank: '적중률 순위',
  profit_rank: '수익률 순위',
  match_pro: '% 적중',
  match_continue: '연속적중',
  chat_game: '최근 1주 프로토 경기별 분석 종합 적중률 흐름',
  chat_betting: '최근 1주 프로토 베팅 박스 종합 적중률 흐름',
  analyst_data: '분석데이터',
  game_num: '회차/경기번호',
  game_category: '종목',
  buy_date: '경기일시',
  team_vs: '홈팀 VS 원정팀',
  is_already_purchase: '구매완료',
  free_price: '무료',
  _p: ' P',
  one_day_package: '1일 패키지',
  ten_day_package: '10일 패키지',
  twenty_day_package: '20일 패키지',
  thirty_day_package: '30일 패키지',
  ask_package: '패키지를 구매하시겠습니까?',
  package_bought: '구매되었습니다.',
  package_not_bought: '패키지를 구매하여야 열람가능합니다.',
  ask_buy_bj: '열람권 {0}개를 사용하여 분석 글을 구매하시겠습니까?',
  data_disabled: '경기가 시작되었으므로 열람이 불가능합니다.\n(특정 기간 내 무료 열람이 가능합니다)',
  ticket_cnt: '현재 보유하고 있는 열람권 : {0}개',
  ticket_cnt1: '현재 보유하고 있는 열람권',
  ticket_cnt_short: '보유 열람권 : {0}개',
  unlimited_view_date: '보유 기간열람권 : ~ {0}',
  pm_game: '분석데이터(오후)',
  eve_game: '분석데이터(저녁)',
  bj_watermark: '[위니] {0} {1}',

  //분석위원
  analyst_winee: '위니 분석위원',
  analyst_intern: '인턴 분석위원',
  analyst_winee_intern: '위니 분석위원, 인턴 분석위원',
  analyst_detail: '분석위원 상세',
  item_buy: '아이템 구매',
  buying: '구매하기',
  preview: '분석글 미리보기',
  no_buy: '구매가능',
  price_format : '{0} P',
  // no_buy_point: '4,500',
  disable_buy: '구매 불가\n(경기시작)',
  no_buy_color: '#0000ff',
  disable_buy_color: '#ff0000',
  use_guide: '이용안내',
  ticket: '열람권',
  proto_game_analyst: '경기별 분석',
  proto_betting: '베팅 박스',
  proto_victory: '승무패',
  proto_victory1: '승무패/승5패/승1패',
  option: '옵션[판매금액]',
  mode_victory1: '기본',
  mode_victory2: '강승부',
  mode_victory3: '초강승부',

  price_game_unselected : '선택',
  price_game_article_1: '단일',
  price_game_article_2: '묶음',
  price_game_article_3: '하루',
  price_game_article_4: '승부',

  daily_special: '오늘의 스페셜',
  daily_special_register: '오늘의 스페셜',
  proto_game_analyst_register: '경기별 분석',
  proto_betting_register: '베팅박스',
  proto_victory_register: '승무패',
  hit_coincidence: '적중 일치',
  choose_area: '선택 내역',
  hit_result: '적중 결과',
  format_game_count: '{0} 경기',
  format_rate: '{0} 배',
  format_pro: '{0}%',
  add_sub_power: '부주력 추가',
  del_sub_power: '부주력 삭제',
  format_won: '{0} 원',
  result_guessing: '결과예상',
  bjNewAddBettingbox : '베팅박스 추가',
  main_power: '주력',
  sub_power: '부주력',
  game_result: '경기결과',
  betting_box: '베팅박스',
  comment: '코멘트',
  sub_power_analyst: '부주력 분석',
  category_turn: '종목/대회',
  game_type: '게임유형',
  end_date: '마감일시',
  choose_rate: '배당률 선택',
  home_team: '홈팀',
  category_all: '종목 전체',
  away_team: '원정팀',
  team1: '홈',
  team2: '원정',
  number: '번호',
  win: '승',
  lose: '패',
  draw: '무',
  one: '1',
  u: 'U',
  o: 'O',
  even : "짝",
  odd : "홀",
  game_date: '경기일시',
  league: '리그',
  betting_line: '베팅박스',
  remark: '비고',
  selected_game_count: '선택경기 수',
  betting_amount: '베팅 금액',
  betting_line_reset: '베팅 박스 리셋',
  expectant_rate: '예상 배당률',
  expectant_amount: '예상 적중금',
  expectant_gain_rate: '예상 수익률',
  expectant_betting_result: '예상 베팅 조합 결과',
  result_rate: '배당률',
  result_amount: '적중금',
  result_gain_rate: '수익률',
  result_betting_result: '베팅 조합 결과',
  win_lose: '승 무 패',
  win_1_lose: '승 1 패',
  win_5_lose: '승 5 패',
  game_number: '경기번호',
  division: '구분',
  domestic: '국내',
  foreign: '해외',
  handycup: '핸디캡',
  endover: '언더오버',
  win1loss: '승1패',
  evenorodd: '홀짝',
  firsthalf: '일반(전반)',
  betting_amount_err: '베팅 금액을 입력하세요.',
  betting_amount_thousand: '베팅 금액은 천단위로 입력하세요.',
  betting_amount_invalid: '베팅 금액은 주력+부주력하여 최대 10만 최소 1천입니다.',
  victory_max: '최대 10만원까지 선택 가능합니다',
  select_data: '경기데이터를 선택해 주세요.',
  select_same_data: '다른 게임유형도 모두 선택하셔야 등록가능합니다.',

  //내분석데이터,
  my_product_info: '패키지 설정',
  product_buy: '상품 구매',
  product_info: '상품관리',
  product_modify : '상품수정',
  product_new : '상품등록',
  package_item : "패키지 기간권",
  product_event_limit : "기간한정상품 ~{0}",
  product_period : "기간권",
  package_item_new : "등록",
  package_item_modify : "수정",
  item_price: '가격',
  item_period: '기간',
  item_sell_period: '판매 기간',
  confirm_delete_product : '등록된 상품을 삭제하시겠습니까?',
  product_deleted_successfully: '등록된 상품이 삭제되었습니다.',
  tb_item_manage: '관리',
  package_name: '패키지명',
  item_description: '설명',
  item_description_hint : '설명을 입력해주세요.',
  item_price_hint: '가격을 입력해주세요.',
  item_period_hint: '패키지 기간을 입력해주세요.',
  item_name_hint: '패키지명을 입력해주세요.',
  item_open_time: "판매 시작 일자",
  item_close_time: "판매 종료 일자",
  item_open_time_hint: '판매 시작 일시를 입력해주세요.',
  item_close_time_hint: '판매 종료 일시를 입력해주세요.',
  item_open_forever: '상시',
  item_package_period: '{0}일권',
  item_package_period_for_user: '{0}일권',
  item_modify_no_product_error: '잘못된 접근입니다.',
  product_saved_successfully : '상품이 정상적으로 등록되었습니다.',
  product_updated_successfully : '상품이 정상적으로 수정정되었습니다.',
  sale_list: '정산관리',
  bj_new: '데이터등록',
  data_list: '내 분석 데이터 목록',
  num: '번호',
  item_name: '상품명',
  price_won: '가격(원)',
  dis_price_won: '할인 가격(원)',
  save: '저장',
  total_order_num: '총 주문건수',
  pay_amount: '결제금액',
  sale_pay_amount: '총 결제금액',
  sale_refund_amount: '환불 금액',
  sale_may_amount: '정산 예정금액',
  purchase_amount: '정산금액',
  order_date: '주문일',
  order_num: '주문번호',
  pdt_name: '상품명',
  orderer_name: '주문자명',
  pay_date: '결제일',
  use_date: '사용일',
  supply_date: '지급일',
  die_date: '소멸일',
  refund_date: '환불일',
  fee: '수수료',
  purchase_date: '정산일',
  status: '상태',
  gon: '건',
  complete: '완료',
  waiting: '예정',
  refund: '환불',
  bj_data_registered: '분석데이터가 등록되었습니다.',
  bj_data_modified: '분석데이터가 수정되었습니다.',
  modify: '수정',
  delete: '삭제',
  ask_delete: '삭제하시겠습니까?',
  unable_modify: '수정이 불가능합니다.\n고객센터에 문의해주세요.',
  unable_delete: '삭제가 불가능합니다.\n고객센터에 문의해주세요.',
  price_setting: '가격설정',
  intro_note_error: '2자 이상 250자 이내로 입력하세요.',
  input_bj_time: '데이터 표의 첫경기 시작 시간을 입력하셔야 합니다',
  input_bj_title : '제목 입력은 필수입니다.',
  input_bj_image : '파일 첨부는 필수입니다.',
  //아이템구매
  item_note1: '설명 문구',
  item_note2: '아이템 설명 문구',
  confirm_buy_item: '<{0}>아이템을 구매하시겠습니까?',
  item_buy_success: '아이템이 구매되었습니다.',

  //이벤트
  date: '날짜',
  empty_event: '이벤트가 없습니다.',

  //고객센터
  kakaoOpenLink : "https://open.kakao.com/o/sJFC40Ug",
  kakaoCs : "카카오톡으로 문의하기",
  kakaoCsOperatingTime : "평일 3시부터 23시\n 주말 11시부터 23시",
  notice: '공지사항',
  faq: '자주 묻는 질문',
  cs: '1:1 문의',
  asking: '문의하기',
  ask_list: '문의내역',
  ask_content: '문의내용',
  ask_content_hint: '문의내용을 입력하세요',
  file_attach: '파일첨부',
  category: '카테고리',
  file_attach_name: '첨부된 파일명.jpg',
  etc: '기타',
  trade: '상품',
  account: '계정',
  payment: '결제',
  error: '오류',
  fraud: '사기',
  service: '서비스',
  exit: '탈퇴',
  normal: '일반',
  _q: 'Q',
  _a: 'A',
  empty_notice: '공지사항이 없습니다.',
  empty_faq: '자주 묻는 질문이 없습니다.',
  empty_cs: '문의내역이 없습니다.',
  cs_do: '문의가 등록되었습니다.',
  title_error: '1자 이상 20자 이내 내용을 입력해주세요.',
  content_error: '1자 이상 500자 이내 내용을 입력해주세요.',

  //마이페이지
  info_modify: '개인정보 수정',
  intro_simple: '한줄 소개',
  intro_avg_upload: '평균 업로드시간',
  intro_simple_error: '2자 이상 30자 이내로 입력하세요.',
  intro_detail: '상세 소개',
  intro_detail_error: '2자 이상 500자 이내로 입력하세요.',
  modify_complete: '변경되었습니다.',
  max_length: '자 이내',
  member_alarm: '알림 설정',
  point_list: '포인트 목록',
  point_history: '포인트 충전/내역',
  coupon_list: '쿠폰 내역',
  pay_list: '구매한 분석 데이터',
  ticket_list: '열람권 내역',
  alarm: '알람',
  alarm_go_list: '알람 목록 가기',
  alarm_list: '알람 목록',
  alarm_unread_guide: '읽지 않은 알람이 {0}개 있습니다.',
  empty_alarm: '확인할 알람이 없습니다.',
  mb_lv: '회원등급',
  coupon: '쿠폰',
  coupon_select: '쿠폰선택',
  analyst_only: '분석위원인 경우에만 구매 가능합니다.',
  use_available: '사용가능',
  reach_end: '마감임박',
  won: '원',
  gae: '개',
  open_date: '발급일',
  close_date: '만료일',
  self_point: '보유 포인트',
  used_point: '사용 포인트',
  point_pay: '포인트 충전',
  point_pay_hint: '포인트 충전을 위한 금액을 입력하세요.',
  point_guide_hint: '꼭! 입금신청을 완료한후에 입금하셔야 포인트 자동충전이 완료됩니다.',
  charge: '충전',
  supply: '지급',
  use: '사용',
  die: '소멸',
  pay_method: '결제 방법',
  card: '카드',
  phone1: '휴대폰',
  bank: '무통장',
  trans: '이체',
  reset: '초기화',
  requesting: '신청 중',
  pay_complete: '결제 완료',
  progressing: '환불 중',
  refunded: '환불 완료',
  pay_cancel: '결제 취소',
  area: '내역',
  direct_input: '직접 입력',
  total_buy_point: '총 구매 포인트',
  paymode_trans: '실시간 계좌이체',
  paymode_phone: '휴대폰 소액결제',
  paymode_nobank: '무통장 입금',
  pay_request: '입금신청',
  pay_requested: '입금신청 되었습니다.',
  pay_account: '입금 계좌',
  pay_account_str: '{0} {1}\n{2}',
  payer_name: '입금자 명',
  payer_name_hint: '한글만 가능',
  payer_name_enter: '입금자명을 입력하세요.',
  pay_confirm_title: '구매 신청 내역',
  pay_confirm_str1: '아래와 같이 구매하려는 아이템의 신청내역을 안내해 드리겠습니다.',
  pay_confirm_str2: '< {0} 포인트 구매 >\n계좌번호 : {1} {2}\n\t\t{3}',
  pay_price: '입금액 : ',
  pay_payer_name: '입금자명 : ',
  pay_confirm_str3: '신청 후 24시간 이내에 입금이 되지 않을 경우 자동 취소 처리됩니다.\n실제 입금자명이나 입금 금액이 다를 경우 취소 처리되어 다시 신청하셔야 합니다.',
  send_sms: '문자로 계좌번호 전송',
  pay_refund1: '위니 포인트 서비스 제공 기간 및 환불 정책, 취소 규정에 대한 안내',
  pay_refund2: '*서비스 제공 기간 - 해당 결제로 얻게 되는 포인트의 서비스 유효기간은 2년입니다. (2년 이내 미사용 시 소멸)',
  pay_refund3: '*환불 및 취소 규정 - 구매한 날로부터 30일 이내 환불 가능합니다. (미사용 포인트에 한하여 부가세를 제외한 금액으로 환불됩니다)',
  point_lack: '포인트 부족',
  point_use: '포인트 차감',
  point_lack_warn: '현재 보유 포인트가 부족합니다.',
  cur_point: '현재 보유 포인트',
  use_point: '차감 포인트',
  point_pay_guide: '[포인트 충전]버튼을 눌러 충전 후 다시 이용해주세요.\n본 분석들은 {0}포인트로 구매할 수 있습니다.\n해당 구매가격은 분석위원이 직접 설정한 금액입니다.',
  point_pay_guide1: '[포인트 충전]버튼을 눌러 충전 후 다시 이용해주세요.',
  point_use_guide: '포인트를 차감하시겠습니까?\n본 분석글은 {0}포인트로 구매할 수 있습니다.\n해당 구매가격은 분석위원이 직접 설정한 금액입니다.',
  confirm_buy: '{0} 분석위원의 데이터를 구매하시겠습니까?',
  enter_coupon_number: '등록할 쿠폰번호를 입력해주세요.',
  coupon_number: '쿠폰번호',
  search_coupon: '쿠폰을 조회하여 주세요.',
  search_coupon_not: '조회할 수 없는 쿠폰입니다.',
  search_coupon_success: '쿠폰조회에 성공하였습니다.\n쿠폰명: {0}\n유효기간: {1}년 {2}월 {3}일\n혜택: {4}{5}원 할인',
  coupon_lv_min: '{0}원 구매시 ',
  registering: '등록하기',
  search: '조회',
  list: '목록',
  not_show_today: '하루동안 보이지 않기',
  not_show_main_banner: '일주일동안 보이지 않기',
  admin: '관리자',
  point_spend: '포인트 사용',
  coupon_use: '쿠폰 사용',
  buy_point: '구매 포인트',
  remain_use: '잔액 사용',
  year: '년',
  times: '회차',
  sun: '일',
  mon: '월',
  tue: '화',
  wed: '수',
  thr: '목',
  fri: '금',
  sat: '토',
  nobank_list: '입금내역',
  nobank_request: '입금 확인 중',
  nobank_complete: '입금 완료',
  nobank_cancel: '입금 취소',
  request_date: '신청일',
  complete_date: '완료일',
  cancel_date: '취소일',

  //chat
  chat: '채팅',
  sport_chat: '스포츠채팅',
  chat_rule: '채팅규정',
  myong: '명',
  str_ignore_on: '이제 {0}님의 대화를 받기 시작합니다.',
  str_ignore_off: '이제부터 {0}님을 무시합니다.',
  chat_invalid: '채팅권한이 없습니다.',
  chat_no_perm: '권한이 없습니다.',
  ignore_on: '무시하기',
  ignore_off: '무시해제',
  do_report: '신고하기',
  chat_report_suc: '{0}님을 {1} 사유로 신고하였습니다. 조속히 조치해 드리겠습니다.',
  report: '신고',
  reason: '사유',
  reason1: '욕설',
  reason2: '거짓 중계',
  reason3: '비매너',
  reason4: '도배',
  reason5: '불법 광고',
  reason6: '관심 끌기',
  reason7: '타회원비하',
  chat_connent: '스포츠 채팅 연결 완료',
  chat_disconnect: '다른 곳에서 접속하였습니다.\n서버 연결 끊김',
  ask_chat_del: '채팅 내역을 삭제하시겠습니까?',
  chat_rule1: '채팅 차단이 되는 경우(차단 수위)',
  chat_rule1_1: '불법 사이트 링크 및 불법 언급(영구 차단)',
  chat_rule1_2: '저작권 위반, 카페, 블로그, 카톡 링크(영구 차단)',
  chat_rule1_3: '운영진 비방 및 욕설(영구차단)',
  chat_rule1_4: '국내 타 스코어 사이트 명시,링크(영구 차단)',
  chat_rule1_5: '의도적인 스코어 거짓 중계(영구 차단)',
  chat_rule1_6: '일반, 낚시성 거짓 중계(30일 차단)',
  chat_rule1_7: '타회원 부모, 가족욕설(아이디 삭제/형사 고소 협조)',
  chat_rule1_8: '지역감정 유발/기타 분란 행위(영구 차단)',
  chat_rule1_9: '욕설/싸움/기타 비매너 행위(15일 차단)',
  chat_rule1_10: '타 회원 비하 발언(호구, 목돌아간)(50일 차단)',
  chat_rule2: '대화가 금지되는 경우 (금지시간)',
  chat_rule2_1: '도배(60분)',
  chat_rule2_2: 'ㄹㄷ어ㅇㅁ 같은 무의미한 단어반복(30분)',
  chat_rule2_3: '관심을 끌기위한 대화반복(15분)',
  chat_rule2_4: '불법 사이트를 유도하는 대화라고 판단되는 경우(30분)',
  chat_rule2_5: '기타 채팅창 분위기를 해치고 있다고 판단되어 경고가 필요한 경우(20분)',
  sec_ago: '초 전',
  min_ago: '분 전',
  hour_ago: '시간 전',
  day_ago: '일 전',

  tb_game_category: "구분",
  tb_round_info: "회차/경기정보",
  tb_analyst_member: "분석위원",
  tb_bj_name: "분석위원명",
  tb_game_date: "경기일시",
  tb_title: "제목",
  tb_upload_date: "업로드일시",
  tb_purchase_availability: "구매",
  tb_price: "가격",


  dat_normal : "일반 데이터",
  dat_special : "스페셜 데이터",
  dat_normal_desc : '분석데이터를 확인할 수 있습니다.',
  dat_special_desc : '분석데이터와 베팅내역을 확인할 수 있습니다.\n만약 손실이 발생할 경우, 전액 환불해드립니다.',
  dat_buy : '구매',
  bo_title : "상품 구매",
  betting_box_bj_guide : "베팅박스를 선택하여, 2배의 금액으로 판매가 가능합니다.\n만약 손실이 발생할 경우, 해당 판매 금액은 구매자에게 전액 환불됩니다.",
  refund_msg : '*손실 발생 시, 경기 종료 이후 한 시간 후에 환불됩니다.'
}
